import store from "../store";
import {AppContext} from "./AppContext";

export function getAppContext() : AppContext {
  return store.getState().appContext;
}
